<template>
  <footer
    class="mainfooter"
    role="contentinfo"
    id="footer"
  >
    <div class="wp_mainFooterContainer">
      <div class="container wp_FooterContainer">
        <div class="row pt-3 pb-3 m-0">
          <div class="col-12 col-md-6 col-xl-3">
            <h5 data-test="footerHead1" id="footerHead1">About</h5>
            <ul>
              <li>
                <router-link
                  :to="{path :'/pages/about',
                  query: {
                    display_text: 'About Us',
                  }}"
                  id="footerLink1-about-us"
																		data-test="footerLink1"
                >
                  About Us
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{path :'/pages/contact',
                  query: {
                    display_text: 'Contact Us',
                  }}"
                  id="footerLink2-contact-us"
																		data-test="footerLink2"
                >
                  Contact Us
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{path :'/pages/privacy',
                  query: {
                    display_text: 'Privacy Policy',
                  }}"
                  id="footerLink3-privacy-policy"
																		data-test="footerLink3"
                >
                  Privacy Policy
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{path :'/pages/terms',
                  query: {
                    display_text: 'Terms and Conditions',
                  }}"
                  id="footerLink4-terms-condition"
																		data-test="footerLink4"
                >
                  Terms and Conditions
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6 col-xl-3 wp_paymentSecured">
            <h5 data-test="footerHead2" id="footerHead2">Payments Secured By</h5>
            <p>
              <img
                src="@/assets/img/cards/razorPay.png"
                alt="Razorpay"
																data-test="footerImg1"
																id="footerImg1"
              >
            </p>
            <ul>
              <li>
                <img
                  src="@/assets/img/cards/1.png"
                  alt="Brand Logos"
																		data-test="footerImg2"
																		id="footerImg2"
                >
              </li>
              <li>
                <img
                  src="@/assets/img/cards/2.png"
                  alt="Brand Logos"
																		data-test="footerImg3"
																		id="footerImg3"
                >
              </li>
              <li>
                <img
                  src="@/assets/img/cards/3.png"
                  alt="Brand Logos"
																		data-test="footerImg4"
																		id="footerImg4"
                >
              </li>
              <li>
                <img
                  src="@/assets/img/cards/25.png"
                  alt="Brand Logos"
																		data-test="footerImg5"
																		id="footerImg5"
                >
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <h5 data-test="footerHead2" id="footerHead2-contact-address">Contact Address</h5>
            <ul>
              <li data-test="footerHead3" id="footerHead3">
															The Neo Bank,
                <br data-test="footerHead4" id="footerHead4">Attn: Customer Service Ctr.,
                <br data-test="footerHead5" id="footerHead5">409 Silverside Road, Suite 105,
                <!--<br>-->
                <br data-test="footerHead6" id="footerHead6">Wilmington, DE 19809
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <h5 data-test="footerHead7" id="footerHead7">News Letter</h5>
            <div class="wp_newsLeterFormContainer">
              <p data-test="footerHead8" id="footerHead8">
                Know about the upcoming Special Events and New Products via Email Newsletter.
              </p>
              <!--<form action>-->
              <!--<input type="text" placeholder="Email address" name="mail" required>-->
              <!--<input type="submit" value="Subscribe">-->
              <!--</form>-->
              <news-letter-form>
              </news-letter-form>
            </div>
            <!-- <div class="wp_foterSocialIconsContainer">
              <ul>
                <li>
                  <span data-test="footerSpan1">
                    <i class="fab fa-facebook-f"></i>
                  </span>
                </li>
                <li>
                  <span data-test="footerSpan2">
                    <i class="fab fa-twitter"></i>
                  </span>
                </li>
                <li>
                  <span data-test="footerSpan3">
                    <i class="fab fa-linkedin-in"></i>
                  </span>
                </li>
                <li>
                  <span data-test="footerSpan4">
                    <i class="fab fa-instagram"></i>
                  </span>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="wp_copyrightAreaContainer">
      <div class="container wp_maxWidth1800">
        <div class="row m-0 ">
          <div class="col-12  col-lg-8 wp_footerIconsAlignment">
            <ul>
													<li>
                <!--to="/vendorLogin"-->
                <router-link
                  to="/vendorLogin"
                  id="seller-login"
																		data-test="footerLink5"
                >
                  <span>
                    <svg
                      viewBox="0 -31 512 512"
                      xmlns="http://www.w3.org/2000/svg"
																						data-test="footerSvg1"
                    >
                      <path d="m211 240h90v30h-90zm0 0"></path>
                      <path d="m415.378906 270h-84.378906v15c0
                      8.289062-6.710938 15-15 15h-120c-8.289062
                      0-15-6.710938-15-15v-15h-84.378906c-19.394532
                      0-36.546875-12.363281-42.6875-30.761719l-53.933594-161.828125v327.589844c0
                      24.8125 20.1875 45 45 45h422c24.8125 0 45-20.1875
                      45-45v-327.578125l-53.9375 161.816406c-6.136719
                      18.398438-23.289062 30.761719-42.683594 30.761719zm0 0">
                      </path>
                      <path d="m316 0h-120c-24.8125 0-45 20.1875-45
                      45v15h-125.191406l56.574218 169.746094c2.050782
                      6.136718 7.777344 10.253906 14.238282
                      10.253906h84.378906v-15c0-8.289062 6.710938-15
                      15-15h120c8.289062 0 15 6.710938 15
                      15v15h84.378906c6.460938 0 12.1875-4.117188
                      14.238282-10.253906l56.578124-169.746094h-125
                      .195312v-15c0-24.8125-20.1875-45-45-45zm-135
                      60v-15c0-8.277344
                      6.722656-15 15-15h120c8.277344
                      0 15 6.722656 15 15v15zm0 0">
                      </path>
                    </svg>
                  </span>
                  Be a Vendor
                </router-link>
              </li>
              <li>
                <router-link
                  to="/agentSignUp"
                  id="footerLink6-agent-login"
																		data-test="footerLink6"
                >
                  <span>
                    <svg
                      viewBox="0 -31 512 512"
                      xmlns="http://www.w3.org/2000/svg"
																						data-test="footerSvg2"
																						id="footerSvg2"
                    >
                      <path d="m211 240h90v30h-90zm0 0"></path>
                      <path d="m415.378906 270h-84.378906v15c0 8.289062-6.710938 15-15 15h-120c-8.289062 0-15-6.710938-15-15v-15h-84.378906c-19.394532 0-36.546875-12.363281-42.6875-30.761719l-53.933594-161.828125v327.589844c0 24.8125 20.1875 45 45 45h422c24.8125 0 45-20.1875 45-45v-327.578125l-53.9375 161.816406c-6.136719 18.398438-23.289062 30.761719-42.683594 30.761719zm0 0"></path>
                      <path d="m316 0h-120c-24.8125 0-45 20.1875-45 45v15h-125.191406l56.574218 169.746094c2.050782 6.136718 7.777344 10.253906 14.238282 10.253906h84.378906v-15c0-8.289062 6.710938-15 15-15h120c8.289062 0 15 6.710938 15 15v15h84.378906c6.460938 0 12.1875-4.117188 14.238282-10.253906l56.578124-169.746094h-125.195312v-15c0-24.8125-20.1875-45-45-45zm-135 60v-15c0-8.277344 6.722656-15 15-15h120c8.277344 0 15 6.722656 15 15v15zm0 0"></path>
                    </svg>
                  </span>
                  Be an Agent
                </router-link>
              </li>
              <li>
                <span data-test="footerSpan5" id="footerSpan5">
                  <span>
                    <svg
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      viewBox="0 0 511.999 511.999"
                      style="enable-background:new 0 0 511.999 511.999;"
                      xml:space="preserve"
																						data-test="footerSvg3"
																						id="footerSvg3"
                    >
                      <g>
                        <g>
                          <path d="M467.069,212.578L267.381,12.861c-11.777-11.748-30.828-11.609-42.451-0.015c-11.689,11.719-11.689,30.747,0,42.451
			L424.647,255c11.7,11.7,30.721,11.7,42.422,0C478.801,243.268,478.801,224.308,467.069,212.578z"></path>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M210.115,82.905l-1.503,7.534c-10.587,52.958-36.317,103.269-71.118,144.046l108.647,108.647
			c40.772-34.794,90.39-61.215,143.35-71.815l7.548-1.503L210.115,82.905z"></path>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M117.575,256.989l-74.253,74.238c-17.545,17.545-17.618,46.029,0,63.647l42.422,42.422
			c17.545,17.545,46.029,17.617,63.647,0l74.246-74.246L117.575,256.989z M128.181,373.664c-5.859,5.859-15.352,5.859-21.211,0
			c-5.859-5.859-5.859-15.352,0-21.211l21.211-21.211c5.859-5.859,15.352-5.859,21.211,0c5.859,5.859,5.859,15.352,0,21.211
			L128.181,373.664z"></path>
                        </g>
                      </g>
                      <g>
                      </g>
                      <g>
                        <g>
                          <path d="M346.864,0c-8.291,0-15,6.709-15,15v30c0,8.291,6.709,15,15,15c8.291,0,15-6.709,15-15V15
			C361.864,6.709,355.155,0,346.864,0z"></path>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M466.864,120h-30c-8.291,0-15,6.709-15,15s6.709,15,15,15h30c8.291,0,15-6.709,15-15S475.155,120,466.864,120z"></path>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M447.469,34.394c-5.859-5.859-15.352-5.859-21.211,0l-30,30c-5.859,5.859-5.859,15.352,0,21.211s15.352,5.86,21.211,0
			l30-30C453.328,49.746,453.328,40.253,447.469,34.394z"></path>
                        </g>
                      </g>
                    </svg>

                  </span>
                  Advertise
                </span>
              </li>
              <li>
                <router-link to="/user/giftCards"
																													data-test="footerLink7" id="footerLink7">
                  <span>
                    <svg
                      height="682pt"
                      viewBox="-21 -97 682.66669 682"
                      width="682pt"
                      xmlns="http://www.w3.org/2000/svg"
																						data-test="footerSvg4"
																						id="footerSvg4"
                    >
                      <path d="m151.25 107.75c-20.625 0-37.5
                      16.875-37.5 37.5s16.875 37.5
                      37.5
                      37.5h37.5v-37.5c0-20.625-16.875-37.5-37.5-37.5zm-151.25-112.5v187.5h86.375c-6.375-10.875-10.125-24-10.125-37.5
                      0-41.25 33.75-75 75-75 13.5 0 26.625 3.75
                      37.5 10.121094v-85.121094zm263.75 112.5c-20.625
                      0-37.5 16.875-37.5 37.5v37.5h37.5c20.625 0
                      37.5-16.875 37.5-37.5s-16.875-37.5-37.5-37.5zm-37.5-112.5v85.121094c10.875-6.371094 24-10.121094
                      37.5-10.121094 41.25 0 75 33.75 75 75 0
                      13.5-3.75 26.625-10.125 37.5h311.375v-187.5zm-75
                      327.75v9.75c0 41.25-33.75 75-75 75v-37.5c20.625
                      0 37.5-16.875 37.5-37.5v-9.75c0-38.625 14.25-75
                      39-102.75h-152.75v262.5h188.75v-245.625c-23.625
                      21.75-37.5 52.5-37.5 85.875zm111-102.75c24.75 27.75
                      39 64.125 39 102.75v9.75c0 20.625 16.875 37.5
                      37.5 37.5v37.5c-41.25 0-75-33.75-75-75v-9.75c0-33.375-13.875-64.125-37.5-85.875v245.625h413.75v-262.5zm151.5 187.5h-37.5v-37.5h37.5zm75 0h-37.5v-37.5h37.5zm75
                      0h-37.5v-37.5h37.5zm0-75h-187.5v-37.5h187.5zm0 0">
                      </path>
                    </svg>
                  </span>
                  Gift Cards
                </router-link>
              </li>
              <li>
                <span data-test="footerSpan6" id="footerSpan6">

                  <span>
                    <svg
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      id="footerSvg5"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="31.357px"
                      height="31.357px"
                      viewBox="0 0 31.357 31.357"
                      style="enable-background:new 0 0 31.357 31.357;"
                      xml:space="preserve"
																						data-test="footerSvg5"
                    >
                      <g>
                        <path d="M15.255,0c5.424,0,10.764,2.498,10.764,8.473c0,
                        5.51-6.314,7.629-7.67,9.62c-1.018,1.481-0.678,
                        3.562-3.475,3.562 c-1.822,0-2.712-1.482-2.712-2.838c0-5.046,
                        7.414-6.188,7.414-10.343c0-2.287-1.522-3.643-4.066-3.643
                        c-5.424,0-3.306,5.592-7.414,5.592c-1.483,0-2.756-0.89-2.756-2.584C5.339,3.683,10.084,0,15.255,0z M15.044,
                        24.406 c1.904,0,3.475,1.566,3.475,3.476c0,1.91-1.568,
                        3.476-3.475,3.476c-1.907,0-3.476-1.564-3.476-3.476 C11.568,25.973,13.137,24.406,15.044,24.406z">
                        </path>
                      </g>
                    </svg>
                  </span>
                  Help Center
                </span>
              </li>
            </ul>
          </div>

          <div class="col-12 col-lg-4 text-center">
            <div class="iconnect">
              <p>
                Powered By
              </p>
              <a href="https://iconnect101.com/">
                <img
                  src="https://tst-ecommerce.s3.amazonaws.com/women-power/PROFILE_PICTURE889976536-d0b4d89a-22e6-49ef-a548-2c3b8fdcba12.png"
                  alt="iconnectLogo"
                  srcset=""
                >
              </a>
            </div>

          </div>
        </div>
        <div class="row m-0">
          <div class="col-12">
            <p
              id="copyright"
              class="text-center"
            >&copy; Copyright {{new Date().getFullYear()}} - All rights reserved.</p>
          </div>
        </div>
      </div>
      <!-- <div class="footer-top p-y-2 d-none">
      <div class="container-fluid"></div>
      </div>-->
      <!--<div class="footer-middle">-->
      <!--<div class="footer-body mx-auto">-->
      <!--<div class="row">-->
      <!--&lt;!&ndash; <div class="col-md-3 col-sm-6">-->
      <!--<div class="footer-pad">-->
      <!--<h4>Address</h4>-->
      <!--<address>-->
      <!--<ul class="list-unstyled">-->
      <!--<li>-->
      <!--City Hall<br>-->
      <!--212  Street<br>-->
      <!--Lawoma<br>-->
      <!--735<br>-->
      <!--</li>-->
      <!--<li>-->
      <!--Phone: 0-->
      <!--</li>-->
      <!--</ul>-->
      <!--</address>-->
      <!--</div>-->
      <!--</div> &ndash;&gt;-->
      <!--<div class="col-md-3 col-sm-6">-->
      <!--&lt;!&ndash;Column1&ndash;&gt;-->
      <!--<div class="footer-pad">-->
      <!--<h5 id="popular-footer">Popular Services</h5>-->
      <!--<ul class="list-unstyled">-->
      <!--<li><a href="#"></a></li>-->
      <!--<li><a href="#" id="payment-footer">Payment Center</a></li>-->
      <!--<li><a href="#" id="contact-footer">Contact Directory</a></li>-->
      <!--<li><a href="#" id="forms-footer">Forms</a></li>-->
      <!--<li><a href="#" id="news-footer">News and Updates</a></li>-->
      <!--<li><a href="#" id="paymentfaq-footer">FAQs</a></li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="col-md-3 col-sm-6">-->
      <!--&lt;!&ndash;Column1&ndash;&gt;-->
      <!--<div class="footer-pad">-->
      <!--<h5 id="website-footer">Website Information</h5>-->
      <!--<ul class="list-unstyled">-->
      <!--<li><a href="#" id="webtutorial-footer">Website Tutorial</a></li>-->
      <!--<li><a href="#" id="accessibility-footer">Accessibility</a></li>-->
      <!--<li><a href="#" id="disclaimer-footer">Disclaimer</a></li>-->
      <!--<li><a href="#" id="privacy-footer">Privacy Policy</a></li>-->
      <!--<li><a href="#" id="websfaq-footer">FAQs</a></li>-->
      <!--<li><a href="#" id="webmaster-footer">Webmaster</a></li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="col-md-3 col-sm-6">-->
      <!--&lt;!&ndash;Column1&ndash;&gt;-->
      <!--<div class="footer-pad">-->
      <!--<h5 id="follow-footer">Follow us</h5>-->
      <!--<ul class="list-unstyled">-->
      <!--<li><a href="#" id="facebook-footer">Facebook</a></li>-->
      <!--<li><a href="#" id="twitter-footer">Twitter</a></li>-->
      <!--<li><a href="#" id="intsgram-footer">Instagram</a></li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="col-md-3 col-sm-6">-->
      <!--<div class="form-group">-->
      <!--<h5 for="" id="newsletter-footer">Sign up for our Newsletter</h5>-->
      <!--<div class="input-group mb-3">-->
      <!--<input type="email" class="form-control" placeholder="Email"
      aria-label="Recipient's username" aria-describedby="basic-addon2"-->
      <!--id="newsletter-email">-->
      <!--<div class="input-group-append">-->
      <!--<button class="btn btn-outline-secondary" type="button"-->
      <!--id="newsletter-btn"></button>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="row">-->
      <!--<div class="col-md-6 d-none d-md-block">-->
      <!--<img src="@/assets/img/trust-01.png" alt=""-->
      <!--id="footerimg">-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!-- <div class="footer-bottom row">-->
      <!--<div class="col-0 d-none d-md-block col-md-3 order-1 order-md-1"></div>-->
      <!--<div class="col-12 col-md order-3 order-md-2">-->
      <!--<div class="iconnect">-->
      <!--<p>-->
      <!--Powered By-->
      <!--</p>-->
      <!--<img src="@/assets/img/iconnect-logo.png"-->
      <!--alt=""-->
      <!--srcset=""-->
      <!--&gt;-->
      <!--</div>-->
      <!--<div class="container">-->
      <!--Footer Bottom-->
      <!-- <p>
            <router-link to="/pages/privacy"
                         id="privacy-policy"
            >
              Privacy Policy
            </router-link>
            <span>|</span>
            <router-link to="/pages/terms"
                         id="terms-condition"
            >
              Terms and Conditions
            </router-link>
      <span>|</span>-->
      <!--<a href="#"-->
      <!--id="site-map">-->
      <!--Sitemap-->
      <!--</a>-->
      <!--<span>|</span>-->
      <!-- <router-link to="/pages/about"
                         id="about-us"
            >
              About Us
            </router-link>

            <span>|</span>
            <router-link to="/vendorLogin"
                         id="seller-login"
            >
              Seller Login
      </router-link>-->
      <!--<span>|</span>-->
      <!--<router-link to="/pages/TenantLogin"-->
      <!--id="tenant-login"-->
      <!--&gt;-->
      <!--Tenant Login-->
      <!--</router-link>-->
      <!-- </p>
          <p id="copyright">
            &copy; Copyright {{new Date().getFullYear()}} - All rights reserved.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-3 col-sm-6 order-2 order-md-3">
        <div class="form-group">
          <h5 for="" id="newsletter-footer">
            Sign up for our Newsletter
          </h5>
          <news-letter-form>
          </news-letter-form>
        </div>
      </div>-->
    </div>
  </footer>
  <!-- footer -->
</template>

<script>
import NewsLetterForm from '@/components/shared/forms/newsLetterForm'

export default {
	components: {
		NewsLetterForm
	}
}
</script>
